module.exports = __webpack_public_path__ + "static/media/plaque_rose_2018.9db6f716.png";